module.exports = "/_next/static/images/gradientBgWithSymbol-75fd68f238c1eed58b7754d6c31b586c.jpg";